export const copyObject = <T extends Record<any, any>>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
};
